import { render, staticRenderFns } from "./EditProductColorComponent.vue?vue&type=template&id=7777daf2&scoped=true"
import script from "./EditProductColorComponent.vue?vue&type=script&lang=js"
export * from "./EditProductColorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7777daf2",
  null
  
)

export default component.exports